"use client";

import React, { useEffect, useRef } from "react";


export default function ManifestoSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-visible");
        });
      },
      { threshold: 0 }
    );
    sectionRef?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      id="why-us"
      ref={sectionRef}
      className="section-pad relative overflow-hidden"
      style={{ background: "#1C1917" }}>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10">

        {/* Centered manifesto statement */}
        <div className="text-center mb-20">
          <div className="reveal-hidden mb-6">
            <p className="text-xs font-medium uppercase tracking-widest text-pmu-taupe" style={{ letterSpacing: "0.2em" }}>
              Why We Exist
            </p>
          </div>
          <div className="reveal-hidden delay-1">
            <h2
              className="font-fraunces font-bold text-white leading-tight"
              style={{ fontSize: "clamp(2.2rem, 5vw, 4rem)" }}>

              Food should{" "}
              <span className="italic font-light" style={{ color: "#A8C4D8" }}>nourish</span>,{" "}
              fuel, and bring joy.
            </h2>
          </div>
          <div className="reveal-hidden delay-2 mt-8 max-w-2xl mx-auto">
            <p className="text-base leading-relaxed text-white/50" style={{ fontWeight: 400 }}>It's not just a cookie — it's a Pick Me Up. We believe food should nourish your body, fuel your busy day, and bring joy without compromise. Made from wholesome chickpeas and oats, our cookies are proof that indulgence can be nutritious and delicious.




            </p>
          </div>
        </div>

        {/* Three pillars — clean horizontal */}
        <div className="reveal-hidden delay-3 grid grid-cols-1 sm:grid-cols-3 gap-px"
        style={{ background: "rgba(255,255,255,0.06)", borderRadius: "1rem", overflow: "hidden" }}>

          {[
          { label: "Nourish", desc: "Real ingredients, real nutrition" },
          { label: "Fuel", desc: "Steady energy, no crash" },
          { label: "Joy", desc: "Easy and indulgent" }]?.
          map(({ label, desc }) =>
          <div
            key={label}
            className="p-10 text-center"
            style={{ background: "rgba(255,255,255,0.03)" }}>

              <p className="font-fraunces font-semibold text-white text-lg mb-2">{label}</p>
              <p className="text-sm text-white/40" style={{ fontWeight: 400 }}>{desc}</p>
            </div>
          )}
        </div>

        {/* Marquee */}
        <div
          className="reveal-hidden delay-4 overflow-hidden mt-20 py-6 border-t border-b"
          style={{ borderColor: "rgba(255,255,255,0.06)" }}>

          <div className="marquee-track">
            {[
            "Plant-Based", "·", "Gluten-Free", "·", "9g Protein", "·", "4g Fibre", "·",
            "Low-GI", "·", "No Dairy", "·", "No Eggs", "·", "Chickpeas", "·", "Rolled Oats", "·",
            "Plant-Based", "·", "Gluten-Free", "·", "9g Protein", "·", "4g Fibre", "·",
            "Low-GI", "·", "No Dairy", "·", "No Eggs", "·", "Chickpeas", "·", "Rolled Oats", "·"]?.
            map((item, i) =>
            <span
              key={i}
              className={`px-5 text-xs font-medium uppercase tracking-widest shrink-0 ${
              item === "·" ? "opacity-15" : "opacity-40"}`
              }
              style={{ color: item === "·" ? "#FFFFFF" : "#A8C4D8", letterSpacing: "0.15em" }}>

                {item}
              </span>
            )}
          </div>
        </div>
      </div>
    </section>);

}